/*
 * @Author: ilal 1
 * @Date: 2023-05-10 13:47:15
 * @LastEditors: ilal 1
 * @LastEditTime: 2023-05-12 14:27:14
 * @FilePath: \web 2.0\src\utils\useDialogManager.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import useDialog from "./useDialog";
import React, { useEffect, useRef } from "react";
import { GameOriginalHelpInfoProps } from "@/features/GameOriginal/Common/help/GameOriginalHelpInfo/interface";
import { sys } from "@/Core/utils/system";
import { detectClientEnvironment } from "@/features/clientEnv";
import { getCurrentCountryCode } from "@/utils/countryConfigUtils";
import { DialogIFrameProps } from "@/pages/dialogIFrame/DialogIFrame";
import {
  getPaymentUrlOpenMode,
  shouldOpenPaymentUrlInIframe,
} from "@/pages/dialogIFrame/paymentUrlHandling";
import { useGlobalState, useRefreshDialog } from "@/store/commonStore"; // import LoginRegister from '../pages/LoginRegister/index';import { FarmElementProps } from "@/pages/farmElement";import { BettingRebateProps } from "@/pages/bettingRebate";import { CssLotteryProps } from "@/pages/cssLottery/lottery";import { TaskCenterProps } from "@/pages/TaskCenter";import { RechargeRewardsProps } from "@/pages/rechargeRewards";

import dialogLazyLoad from "@/utils/dialogLazyLoad";
import { IFRedPackConfig } from "@/api/apiRsp/IFRedPack";
import { RedpackRainEntryProps } from "@/pages/redpackRain/RedpackRainEntry";
import DialogInviteWheel from "@/features/invite/dialogInviteWheel/DialogInviteWheel";
import { useUserInfo } from "@/store/userInfo";
import { useNavigate } from "react-router";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import { CssLotteryProps } from "@/pages/cssLottery/lottery";
import { BettingRebateProps } from "@/pages/bettingRebate";
import { FarmElementProps } from "@/pages/farmElement";
import { TaskCenterProps } from "@/pages/TaskCenter";
import { RechargeRewardsProps } from "@/pages/rechargeRewards";
import type { RechargeSpinActivityProps } from "@/pages/rechargeSpinActivity/types";
import { useAuthPopupMode } from "@/pages/LoginRegister/loginRegisterUtils";
import { useGlobalOpenWallet } from "@/store/commonStore";
import { feedback } from "@/utils/feedback";
import { publishWalletTabIntent } from "@/pages/mobilewallet/wallet/walletTabIntent";
import type { InviteShareOptions } from "@/features/invite/inviteLink";

const LoginRegisterDialog = dialogLazyLoad(
  () => import(`../pages/LoginRegister/index`),
  { presentation: "modal-card" }
);

const GoogleTowFactorDialog = dialogLazyLoad(
  () => import("@/pages/GoogleTowFactor"),
  { presentation: "modal-card" }
);

interface historyProps {
  tabIndex?: number;
  uIndex?: number;
  dayIndex?: number;
  typeIndex?: number;
}

interface DialogMgrReturn {
  /**
   * 打开注册弹窗
   * @returns
   */
  openSignUp: () => void;
  openSignIn: () => void;
  //充值中心
  openWallet: (props?: { isHideClose?: boolean; tabIndex?: number }) => void;
  openWheel: (props?: CssLotteryProps) => void;
  /**打开Fairness */
  openVip: () => void;
  openGameIframe: (url, rotate?) => void;
  closeGameIframe: () => void;
  /* 投注返利 */
  openBetting: (props?: BettingRebateProps) => void;
  openBettingDetails: () => void;
  /*  IWD解锁 */
  openIWDunlock: () => void;
  /* 金钱农场 */
  openFarm: (props?: FarmElementProps) => void;
  openFarmDetails: () => void;
  /* 历史记录 */
  openHistoryElement: (props?: any) => void;
  /** 稽核记录 */
  openAuditRecords: () => void;
  openAuditDetailsModule: (props?: any) => void;

  /**安全中心 */
  openSecurity: (closeOther?: boolean) => void;
  /**limbo投注详情 */
  openGameBetInfo: (betData: any) => void;
  /**种子刷新 */
  openSeedSettings: () => void;
  /**打开游戏Help */
  openGameHelp: (props: GameOriginalHelpInfoProps) => void;
  /**打开GameIsThis */
  openGameHelpInfo: (props?: GameOriginalHelpInfoProps) => void;
  /**打开Fairness */
  openFairness: () => void;
  /* 任务中心 */
  openTaskCenter: (props?: TaskCenterProps, force?) => void;
  /* 充值类型 */
  openRechargeTypeElement: (props: any) => void;
  /* 投注规则弹窗 */
  // openCommissionDetails: () => void;
  /* 邀请好友规则弹窗 */
  // openReferralDetails: () => void;

  /* FUN COINS规则弹窗 */
  openFunRules: () => void;

  /* 邀请分享弹窗 */
  openSharePage: (options?: InviteShareOptions) => void;
  /* 邀请好友规则弹窗 */
  openInviteFriendsRulesDialog: () => void;
  /* 代理规则弹窗 */
  openCommissionRulesDialog: () => void;

  /* 佣金奖励历史记录 */
  openBroHistoryDetails: () => void;
  /* 邀请奖励历史记录 */
  opentInvitesHistoryDetails: () => void;
  /**三分游戏投注详情 */
  openThirdGameBetInfo: (betData: any) => void;
  /* 历史记录详情 */
  openDetailsModule: (props: any) => void;
  /* 谷歌二次验证弹窗 */
  openGoogleTowFactor: (props?: any) => void;
  /**充值页面内嵌 */
  openDialogIFrame: (props: DialogIFrameProps) => void;
  /**打开消息提示页面 */
  openDialogNotice: () => void;

  /** 打开红包雨 */
  openRainPack: (props?: RedpackRainEntryProps) => void;
  /**打开fun页面 */
  openFunPage: (tipis?: string) => void;
  /**打开红包雨说明界面 */
  openRedPackInstruction: (data: IFRedPackConfig) => void;
  /**打开邀请转盘 */
  openDialogInviteWheel: () => void;
  /**打开邀请转盘帮助 */
  openDialogInviteWheelHelp: () => void;
  /**打开SuperSpin规则弹窗 */
  openSuperSpinRuleDialog: () => void;
  /**打开充值奖励页面 */
  openRechargeRewards: (props?: RechargeRewardsProps) => void;
  /**打开充值抽奖活动页面 */
  openRechargeSpinActivity: (props?: RechargeSpinActivityProps) => void;
}

const useDialogManager = (): DialogMgrReturn => {
  const { push, replace, close, pushLoadLazy } = useDialog();
  const [, refreshDialog] = useRefreshDialog();
  const [, setAuthPopupMode] = useAuthPopupMode();
  const [, setMobileWalletVisible] = useGlobalOpenWallet();
  const { isLogin } = useGlobalState();

  const { data: userInfo, revalidate: revalidateUserInfo } = useUserInfo(),
    navigate = useNavigate(),
    { t } = useTranslationPlus();

  const ref = useRef(isLogin);
  useEffect(() => {
    ref.current = isLogin;
  }, [isLogin]);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      LoginRegisterDialog.preload?.();
      GoogleTowFactorDialog.preload?.();
    }, 0);

    return () => {
      window.clearTimeout(timer);
    };
  }, []);

  const openSignUp = () => {
    setAuthPopupMode(2);
    pushLoadLazy(
      LoginRegisterDialog,
      {
        key: "LoginRegister",
        presentation: "modal-card",
      }
    );
    //openRainPack()
  };
  const openSignIn = () => {
    setAuthPopupMode(1);
    pushLoadLazy(
      LoginRegisterDialog,
      {
        key: "LoginRegister",
        presentation: "modal-card",
      }
    );
  };
  const openWalletPanel = (props?: { isHideClose?: boolean; tabIndex?: number }) => {
    if (typeof props?.tabIndex === "number") {
      publishWalletTabIntent(props.tabIndex);
    }
    setMobileWalletVisible(true);
  };

  const openWallet = async (props?: { isHideClose?: boolean; tabIndex?: number }) => {
    if (!ref.current) {
      openSignIn();
      return;
    }

    const latestUserInfo =
      userInfo ||
      (await revalidateUserInfo(undefined, { revalidate: true }).catch(
        () => undefined
      ));

    if (latestUserInfo && !latestUserInfo.mobile) {
      feedback.warning(t("ERROR_60046"));
      navigate("/globalSettings/1");
      return;
    }

    openWalletPanel(props);
  };
  const openWheel = (props: CssLotteryProps = {}) => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import(`@/pages/cssLottery`).then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "Wheel",
        props: props,
      }
    );
  };
  // 投注返利
  const openBetting = (props: BettingRebateProps = {}) => {
    if (ref.current) {
      pushLoadLazy(
        dialogLazyLoad(() =>
          import(`@/pages/bettingRebate`).then((res) => {
            refreshDialog({});
            return res;
          })
        ),
        {
          key: "BettingRebate",
          props: props,
        }
      );
    } else {
      openSignIn();
    }
  };
  // 投注返利详情
  const openBettingDetails = () => {
    if (ref.current) {
      pushLoadLazy(
        dialogLazyLoad(() =>
          import("@/pages/bettingRebate/BettingDetailed").then((res) => {
            refreshDialog({});
            return res;
          })
        ),
        {
          key: "BettingDetailed",
        }
      );
    } else {
      openSignIn();
    }
  };
  // IWD解锁
  const openIWDunlock = () => {
    if (ref.current) {
      pushLoadLazy(
        dialogLazyLoad(() =>
          import("@/pages/IWDunlock").then((res) => {
            refreshDialog({});
            return res;
          })
        ),
        {
          key: "IWDunlock",
        }
      );
    } else {
      openSignIn();
    }
  };
  /* 金钱农场 */
  const openFarm = (props: FarmElementProps = {}) => {
    if (ref.current) {
      pushLoadLazy(
        dialogLazyLoad(() =>
          import("@/pages/farmElement").then((res) => {
            refreshDialog({});
            return res;
          })
        ),
        {
          key: "FarmElement",
          props: props,
        }
      );
    } else {
      openSignIn();
    }
  };
  const openFarmDetails = () => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/pages/farmElement/FarmDetails").then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "FarmDetails",
      }
    );
  };
  const openHistoryElement = (props: historyProps) => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/pages/historyElement").then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "HistoryElement",
        props: props,
      }
    );
  };
  const openAuditRecords = () => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/pages/AuditRecords").then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "AuditRecords",
      }
    );
  };
  /* 稽核记录详情弹窗 */
  const openAuditDetailsModule = (props) => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/pages/AuditRecords/details").then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "AuditDetails",
        props: props,
      }
    );
  };

  const openGameIframe = (gameUrl, rotate?) => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/pages/game/components/mobileFrame").then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "MobileFrame",
        props: {
          gameUrl: gameUrl,
          rotate: rotate,
        },
      }
    );
  };
  const closeGameIframe = () => {
    close();
  };
  const openSecurity = (closeOther?: boolean) => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/pages/security").then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "Security",
        props: {
          modle: closeOther ? "2" : "1",
        },
      }
    );
  };

  const openGameBetInfo = (betData) => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/features/GameOriginal/Common/betInfo").then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "GameBetInfo",
        props: {
          betData: betData,
        },
      }
    );
  };

  const openSeedSettings = () => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/features/GameOriginal/Common/seedSettings").then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "SeedSettings",
      }
    );
  };

  const openGameHelp = (props: GameOriginalHelpInfoProps) => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/features/GameOriginal/Common/help").then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "Help",
        props: props,
      }
    );
  };

  const openGameHelpInfo = (props: GameOriginalHelpInfoProps) => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/features/GameOriginal/Common/help/GameOriginalHelpInfo").then(
          (res) => {
            refreshDialog({});
            return res;
          }
        )
      ),
      {
        key: "GameOriginalHelpInfo",
        props: props,
      }
    );
  };

  const openFairness = () => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/features/GameOriginal/Common/help/GameOriginalHelpInfo").then(
          (res) => {
            refreshDialog({});
            return res;
          }
        )
      ),
      {
        key: "GameOriginalHelpInfo",
        props: {
          langKey: "FairnessInfo",
          title: "GameOriginalHelp.Fairness",
        },
      }
    );
  };

  const openTaskCenter = (props: TaskCenterProps = {}, force?) => {
    if (ref.current || force) {
      pushLoadLazy(
        dialogLazyLoad(() =>
          import("@/pages/TaskCenter").then((res) => {
            refreshDialog({});
            return res;
          })
        ),
        {
          key: "TaskCenter",
          props: props,
        }
      );
    } else {
      openSignIn();
    }
  };

  const openVip = () => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/pages/vip").then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "Vip",
      }
    );
  };
  const openRechargeTypeElement = (props: any) => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/pages/Activity/components/RechargeTypeElement/index").then(
          (res) => {
            refreshDialog({});
            return res;
          }
        )
      ),
      {
        key: "openRechargeTypeElement",
        props: props,
      }
    );
  };

  const openCommissionRulesDialog = () => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import(
          "@/pages/AffiliateProxy/components/Details/CommissionDetails"
        ).then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "CommissionDetailsProxy",
      }
    );
  };

  const openInviteFriendsRulesDialog = () => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import(
          "@/pages/AffiliateProxy/components/Details/ReferralDetails"
        ).then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "ReferralDetailsProxy",
      }
    );
  };
  /* 佣金奖励历史记录 */
  const openBroHistoryDetails = () => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import(
          "@/pages/InviteDashBoard/components/Brokerage/historyModel"
        ).then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "BroHistoryDetails",
      }
    );
  };
  /* 邀请奖励历史记录 */
  const opentInvitesHistoryDetails = () => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/pages/InviteDashBoard/components/Invites/historyModel").then(
          (res) => {
            refreshDialog({});
            return res;
          }
        )
      ),
      {
        key: "InvitesHistoryDetails",
      }
    );
  };

  const openThirdGameBetInfo = (betData) => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/pages/game/components/gameDetail").then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "GameDetail",
        props: {
          data: betData,
        },
      }
    );
  };

  /* 历史记录详情弹窗 */
  const openDetailsModule = (props) => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/pages/historyElement/detailsModule").then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "DetailsModule",
        props: props,
      }
    );
  };

  /* 谷歌二次验证弹窗 */
  const openGoogleTowFactor = (props) => {
    pushLoadLazy(
      GoogleTowFactorDialog,
      {
        key: "GoogleTowFactorElement",
        props: props,
        presentation: "modal-card",
      }
    );
  };

  /**打开内嵌弹窗 */
  const openDialogIFrame = (props: DialogIFrameProps) => {
    if (
      props?.type === "pay" &&
      !shouldOpenPaymentUrlInIframe(props?.url, getCurrentCountryCode())
    ) {
      const clientEnv = detectClientEnvironment();
      const openMode = getPaymentUrlOpenMode(
        props?.url,
        getCurrentCountryCode(),
        {
          bucket: clientEnv.bucket,
          ua: {
            isAndroid: clientEnv.ua.isAndroid,
          },
        }
      );

      if (openMode === "host_navigation") {
        window.location.assign(props.url);
        return;
      }

      sys.openUrl(props.url);
      return;
    }

    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/pages/dialogIFrame/DialogIFrame").then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "DialogIFrame",
        props: props,
      }
    );
  };

  /**打开消息提示页面 */
  const openDialogNotice = () => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/pages/dialogNotice/DialogNotice").then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "DialogNotice",
      }
    );
  };

  /* 分享页面 */
  const openSharePage = (options: InviteShareOptions = {}) => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/pages/share").then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "SharePage",
        props: options,
      }
    );
  };

  /**红包雨页面 */
  const openRainPack = (props?: RedpackRainEntryProps) => {
    if (ref.current) {
      pushLoadLazy(
        dialogLazyLoad(() =>
          import("@/pages/redpackRain/RedpackRainEntry").then((res) => {
            refreshDialog({});
            return res;
          })
        ),
        {
          key: "RedpackRainEntry",
          props: props,
        }
      );
    } else {
      openSignUp();
    }
  };

  const openFunPage = (tipis?: string) => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/pages/funList").then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "FunPage",
        props: {
          tipis: tipis,
        },
      }
    );
  };

  const openRedPackInstruction = (data: IFRedPackConfig) => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/pages/redpackRain/instruction/RedPackInstruction").then(
          (res) => {
            refreshDialog({});
            return res;
          }
        )
      ),
      {
        key: "RedPackInstruction",
        props: {
          data,
        },
      }
    );
  };

  const openDialogInviteWheel = () => {
    push({
      children: <DialogInviteWheel />,
      key: "DialogInviteWheel",
    });

  };

  const openDialogInviteWheelHelp = () => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import(
          "@/features/invite/dialogInviteWheel/component/InviteWheelHelp/InviteWheelHelp"
        ).then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "InviteWheelHelp",
      }
    );
  };

  /* FUN COINS规则弹窗 */
  const openFunRules = () => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import("@/pages/funRules/FunRules").then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "FunRules",
      }
    );
  };

  /**打开SuperSpin规则弹窗 */
  const openSuperSpinRuleDialog = () => {
    pushLoadLazy(
      dialogLazyLoad(() =>
        import(
          "@/features/GameOriginal/superSpin/dialogs/SuperSpinRuleDialog"
        ).then((res) => {
          refreshDialog({});
          return res;
        })
      ),
      {
        key: "SuperSpinRuleDialog",
      }
    );
  };

  /**打开充值奖励页面 */
  const openRechargeRewards = (props: RechargeRewardsProps = {}) => {
    if (ref.current) {
      pushLoadLazy(
        dialogLazyLoad(() =>
          import("@/pages/rechargeRewards").then((res) => {
            refreshDialog({});
            return res;
          })
        ),
        {
          key: "RechargeRewards",
          props: props,
        }
      );
    } else {
      openSignIn();
    }
  };

  /**打开充值抽奖活动页面 */
  const openRechargeSpinActivity = (props: RechargeSpinActivityProps = {}) => {
    if (ref.current) {
      pushLoadLazy(
        dialogLazyLoad(() =>
          import("@/pages/rechargeSpinActivity").then((res) => {
            refreshDialog({});
            return res;
          })
        ),
        {
          key: "RechargeSpinActivity",
          props,
          presentation: "page",
        }
      );
    } else {
      openSignIn();
    }
  };

  return {
    openSignUp,
    openSignIn,
    openWallet,
    openWheel,
    openBetting,
    openBettingDetails,
    openIWDunlock,
    openFarm,
    openFarmDetails,
    openHistoryElement,
    openAuditRecords,
    openAuditDetailsModule,
    openGameIframe,
    closeGameIframe,
    openSecurity,
    openGameBetInfo,
    openSeedSettings,
    openGameHelp,
    openGameHelpInfo,
    openFairness,
    openTaskCenter,
    openVip,
    openRechargeTypeElement,
    // openReferralDetails,
    // openCommissionDetails,
    openBroHistoryDetails,
    openCommissionRulesDialog,
    openInviteFriendsRulesDialog,
    opentInvitesHistoryDetails,
    openThirdGameBetInfo,
    openDetailsModule,
    openGoogleTowFactor,
    openDialogIFrame,
    openDialogNotice,
    openSharePage,
    openRainPack,
    openFunPage,
    openRedPackInstruction,
    openDialogInviteWheel,
    openDialogInviteWheelHelp,
    openFunRules,
    openSuperSpinRuleDialog,
    openRechargeRewards,
    openRechargeSpinActivity,
  };
};

export default useDialogManager;
